import { type ReactNode, useMemo } from 'react';

import { config } from '~shared/config';

import {
  type AddressSuggestionApi,
  AddressSuggestionApiProvider as AddressSuggestionApiProvideLib,
} from '@breezeventures/web-ph-address-suggestions/api';

import { getAddressSuggestions } from '../api';

type AddressSuggestionApiProviderProps = {
  children: ReactNode;
};

export const AddressSuggestionApiProvider = ({
  children,
}: AddressSuggestionApiProviderProps) => {
  const addressSuggestionApi = useMemo<AddressSuggestionApi>(
    () => ({
      getAddressSuggestion: async (params) =>
        getAddressSuggestions({ apiHost: config.apiHost ?? '', ...params }),
    }),
    []
  );

  return (
    <AddressSuggestionApiProvideLib value={addressSuggestionApi}>
      {children}
    </AddressSuggestionApiProvideLib>
  );
};
